import { RegistryGlobalSummaryAny, RegistryGlobalSummaryLegacy } from '../../../types';
import { isGlobalV2 } from './globalFormat';
import GlobalTabLegacy from './GlobalTabLegacy';
import GlobalTabV2 from './GlobalTabV2';

interface GlobalTabProps {
  globalSummary: RegistryGlobalSummaryAny;
}

// 世界观分流：后端透传 global JSON，按字段探测新旧格式后分别渲染。
export default function GlobalTab({ globalSummary }: GlobalTabProps) {
  if (isGlobalV2(globalSummary)) {
    return <GlobalTabV2 globalSummary={globalSummary} />;
  }
  return <GlobalTabLegacy globalSummary={globalSummary as RegistryGlobalSummaryLegacy} />;
}
